import React from 'react';
import { useNavigate } from 'react-router-dom';

const buttons = [
  { title: 'Customers', icon: 'fa-users', bg: 'bg-blue-100 text-blue-700', path: '/customer' },
  { title: 'Invoice', icon: 'fa-file-invoice', bg: 'bg-yellow-100 text-yellow-700', path: '/invoice' },
  { title: 'Expense', icon: 'fa-money-bill-wave', bg: 'bg-red-100 text-red-700', path: '/expense' },
  { title: 'Products', icon: 'fa-box-open', bg: 'bg-green-100 text-green-700', path: '/products' },
  { title: 'Category', icon: 'fa-tags', bg: 'bg-purple-100 text-purple-700', path: '/category' },
  { title: 'Slider', icon: 'fa-sliders', bg: 'bg-pink-100 text-pink-700', path: '/slider' }
];

const AddButtonsDashboard = () => {
  const navigate = useNavigate();
  
  return (
    <div className="overflow-x-auto whitespace-nowrap no-scrollbar p-2 mb-4">
      <div className="flex gap-4">
        {buttons.map((btn, index) => (
          <div
            onClick={() => navigate(btn.path)}
            className={`min-w-[120px] cursor-pointer rounded-xl p-2 shadow-md hover:shadow-lg transition-all flex flex-col items-center justify-center ${btn.bg}`}
          >
            <i className={`fa-solid ${btn.icon} text-2xl mb-2`}></i>
            <span className="text-sm font-medium">{btn.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddButtonsDashboard;
